import { Suspense, lazy } from "react";

import { Route } from "react-router-dom";

// import SecureRoute from "shared/services/AuthDecorator/SecureRoute";
import BasicLayout from "shared/templates/Layouts/BasicLayout";
import type { IApp } from "shared/types";

const GamePage = lazy(() => import("./Pages/Game"));
const AllGamesPage = lazy(() => import("./Pages/AllGames"));
const CategoryGames = lazy(() => import("./Pages/CategoryGames"));

import { routes } from "./constants";

class GameApp implements IApp {
	getRoutes = () => [
		<Route key="game-routes" path={routes.games.getPath()}>
			{/*<Route element={<SecureRoute roles={[]} />}>{this.getSecuredRoutes()}</Route>*/}
			<Route key="game-inner-routes" element={<BasicLayout />}>
				{/*<Route*/}
				{/*	// key={routes.home.getElementKey()}*/}
				{/*	// path={routes.home.getPath()}*/}
				{/*	key={"dashboard"}*/}
				{/*	path={"/"}*/}
				{/*	element={*/}
				{/*		<Suspense>*/}
				{/*			<HomePage />*/}
				{/*		</Suspense>*/}
				{/*	}*/}
				{/*/>*/}
				<Route
					key={routes.games.all.getElementKey()}
					path={routes.games.all.getPath()}
					element={
						<Suspense>
							<AllGamesPage />
						</Suspense>
					}
				/>
				<Route
					key={`${routes.games.category.getElementKey()}/category`}
					path={`${routes.games.category.getPath()}/:categoryId`}
					element={
						<Suspense>
							<CategoryGames />
						</Suspense>
					}
				/>
				<Route
					key={`${routes.games.getElementKey()}/merchant/page`}
					path={`${routes.games.getPath()}/:merchantId/:pageCode`}
					element={
						<Suspense>
							<GamePage />
						</Suspense>
					}
				/>
			</Route>
		</Route>
	];
}

export default GameApp;
